import { render, staticRenderFns } from "./MeetingParticipants.vue?vue&type=template&id=06a67bb8&"
import script from "./MeetingParticipants.vue?vue&type=script&lang=js&"
export * from "./MeetingParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports